module.exports = __webpack_public_path__ + "assets/img/product-government3.76ccf344.png";